<template>
  <v-card>
    <v-container fluid>
      <v-layout 
        :column="$vuetify.breakpoint.xsOnly"
        :justify-space-around="!$vuetify.breakpoint.smAndDown"
      >
        <v-flex
          xs12 sm10 md5 xl4    
        >
          <v-text-field
            v-model="search"
            append-icon="search"
            :label="$t('general.misc.buscar')"
          />
        </v-flex>
      </v-layout>
      <v-layout>
        <v-flex xs12>
          <v-data-table
            :headers="headers"
            :items="filteredItems"
            :loading="waitingForLoad"
            :expand="$vuetify.breakpoint.mdAndDown"
          >
            <template slot="items" slot-scope="props">
              <tr class="pointer" @click="props.expanded = !props.expanded">
                <td class="text-xs-left">
                  <v-layout row>
                    {{ props.item.descripcion }}
                    <v-spacer/>
                  </v-layout>
                </td>
                <td class="text-sm-right hidden-sm-and-down tableSmallPadding">
                  <v-tooltip bottom>
                    <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarEditar(props.item)">
                      <v-icon color="primary">
                        mdi-image
                      </v-icon>
                    </v-btn>
                    <span>{{$t('general.misc.editarImg')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarScoring(props.item)">
                      <v-icon color="primary">
                        mdi-code-less-than-or-equal
                      </v-icon>
                    </v-btn>
                    <span>{{$t('promociones.tasaDeScoring')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarRepresentantes(props.item)">
                      <v-icon color="primary">
                        mdi-signature-freehand
                      </v-icon>
                    </v-btn>
                    <span>{{$t('promociones.representantesResponsive')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarPlantillas(props.item)">
                      <v-icon color="primary">
                        mdi-signature-text
                      </v-icon>
                    </v-btn>
                    <span>{{$t('promociones.plantillasResponsive')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarCuenta(props.item)">
                      <v-icon color="primary">
                        account_balance
                      </v-icon>
                    </v-btn>
                    <span>{{$t('promociones.cuentaCorrienteResponsive')}}</span>
                  </v-tooltip>
                  <v-tooltip bottom>
                    <v-btn flat icon slot="activator" class="smallTableButton" @click.stop="mostrarDocumentos(props.item)">
                      <v-icon style="font-weight:bold" class="custom-icon icon-file" color="primary">
                      </v-icon>
                    </v-btn>
                    <span>{{$t('promociones.documentos')}}</span>
                  </v-tooltip>
                </td>
                <td class="text-xs-right hidden-md-and-up tableSmallPadding">
                  <v-menu
                  transition="scale-transition"
                  origin="top right">
                    <v-btn
                      flat icon title="Gestionar" 
                      slot="activator" 
                      class="smallTableButton"
                    >
                      <v-icon color="primary">
                        more_vert
                      </v-icon>
                    </v-btn>
                    <v-list dense>
                      <v-list-tile 
                        @click="mostrarEditar(props.item)"
                      >
                        <v-list-tile-action>
                          <v-icon color="primary"> mdi-image </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t('general.misc.editarImg')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile 
                        @click="mostrarScoring(props.item)"
                      >
                        <v-list-tile-action>
                          <v-icon color="primary"> mdi-code-less-than-or-equal </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t('promociones.tasaDeScoring')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile 
                        @click="mostrarRepresentantes(props.item)"
                      >
                        <v-list-tile-action>
                          <v-icon color="primary"> mdi-signature-freehand </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t('promociones.representantesResponsive')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile
                        @click="mostrarPlantillas(props.item)"
                      >
                        <v-list-tile-action>
                          <v-icon color="primary"> mdi-signature-text </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t('promociones.plantillasResponsive')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile
                        @click="mostrarCuenta(props.item)"
                      >
                        <v-list-tile-action>
                          <v-icon color="primary"> account_balance </v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t('promociones.cuentaCorrienteResponsive')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                      <v-list-tile
                        @click="mostrarDocumentos(props.item)"
                      >
                        <v-list-tile-action>
                          <v-icon style="font-weight:bold" class="custom-icon icon-file" color="primary"></v-icon>
                        </v-list-tile-action>
                        <v-list-tile-content>
                          <v-list-tile-title>
                            {{$t('promociones.documentos')}}
                          </v-list-tile-title>
                        </v-list-tile-content>
                      </v-list-tile>
                    </v-list>
                  </v-menu>
                </td>           
              </tr>
            </template>
          </v-data-table>
        </v-flex>
      </v-layout>
    </v-container>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarEditarPromocion" 
        v-model="mostrarEditarPromocion"
        :cambiado="cambiado"
        @aceptar="mostrarEditarPromocion = $event"
      >
        <PopUpImagenPromocion 
          :codigoPromocion="codigoPromocionEditar"
          @cambiado="cambiado = $event"
          @recargar="initialize"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarPromocionRepresentantes" 
        v-model="mostrarPromocionRepresentantes"
        :cambiado="cambiado"
        @aceptar="mostrarPromocionRepresentantes = $event; cambiado = false"
      >
        <PopUpPromocionesRepresentantes
          :codigoPromocion="codigoPromocionEditar"
          @cambiado="cambiado = $event"
          @recargar="initialize"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarPromocionPlantillas" 
        v-model="mostrarPromocionPlantillas"
        :cambiado="cambiado"
        @aceptar="mostrarPromocionPlantillas = $event"
      >
        <PopUpPromocionesPlantillas 
          :codigoPromocion="codigoPromocionEditar"
          @cambiado="cambiado = $event"
          @recargar="initialize"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarPromocionScoring" 
        v-model="mostrarPromocionScoring"
        :cambiado="cambiado"
        @aceptar="mostrarPromocionScoring = $event"
      >
        <PopUpPromocionTasaScoring 
          :codigoPromocion="codigoPromocionEditar"
          @cambiado="cambiado = $event"
          @recargar="initialize"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarPromocionCuenta" 
        v-model="mostrarPromocionCuenta"
        :cambiado="cambiado"
        @aceptar="mostrarPromocionCuenta = $event"
      >
        <PopUpCuentaCorriente
          :codigoPromocion="codigoPromocionEditar"
          @cambiado="cambiado = $event"
          @recargar="initialize"
        />
      </custom-dialog>
    </v-fade-transition>
    <v-fade-transition>
      <custom-dialog 
        v-if="mostrarPromocionDocumento" 
        v-model="mostrarPromocionDocumento"
        :cambiado="cambiado"
        @aceptar="mostrarPromocionDocumento = $event"
      >
        <PopUpPromocionesDocumentos
          :codigoPromocion="codigoPromocionEditar"
          @cambiado="cambiado = $event"
          @recargar="initialize"
        />
      </custom-dialog>
    </v-fade-transition>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import rulesMixin from '@/mixins/rules.js'
import PopUpImagenPromocion from './PopUpImagenPromocion'
import PopUpPromocionesRepresentantes from './PopUpPromocionesRepresentantes'
import PopUpPromocionesPlantillas from './PopUpPromocionesPlantillas'
import PopUpPromocionTasaScoring from './PopUpPromocionTasaScoring'
import PopUpCuentaCorriente from './PopUpCuentaCorriente'
import PopUpPromocionesDocumentos from './PopUpPromocionesDocumentos'

export default {
  mixins: [
    rulesMixin
  ],
  components: {
    PopUpImagenPromocion,
    PopUpPromocionesRepresentantes,
    PopUpPromocionesPlantillas,
    PopUpPromocionTasaScoring,
    PopUpCuentaCorriente,
    PopUpPromocionesDocumentos
  },
  data () {
    return {
      items: [],
      mostrarEditarPromocion: false,
      mostrarPromocionRepresentantes: false,
      mostrarPromocionPlantillas: false,
      mostrarPromocionScoring: false,
      mostrarPromocionCuenta: false,
      mostrarPromocionDocumento: false,
      search: null,
      waitingForLoad: false,
      codigoPromocionEditar: null,
      cambiado: false
    }
  },
  created () {
    this.initialize()
  },
  computed: {
    ...mapGetters({
      usuario: 'login/usuario',
      promociones: 'promociones/getAll'
    }),
    headers () {
      return [
        {
          text: this.$t('promociones.descripcion'),
          value: 'descripcion',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.misc.acciones'),
          align: 'right',
          sortable: false
        }
      ]
    },
    filteredItems () {
      if (this.waitingForLoad) {
        return []
      }
      let auxItems = this.items
      if (this.search != null && this.search.length > 0) {
        let normalizedSearchValue = this.search.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase()
        auxItems = auxItems.filter(x =>
          (x.descripcion.normalize('NFD')
            .replace(/[\u0300-\u036f]/g, '')
            .toLowerCase()
            .includes(normalizedSearchValue)
          )
        )
      }
      return auxItems
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadPromociones: 'promociones/loadAll'
    }),
    mostrarEditar (obj) {
      this.codigoPromocionEditar = obj.codigo
      this.mostrarEditarPromocion = true
    },
    mostrarRepresentantes (obj) {
      this.codigoPromocionEditar = obj.codigo
      this.mostrarPromocionRepresentantes = true
      this.cambiado = false
    },
    mostrarPlantillas (obj) {
      this.codigoPromocionEditar = obj.codigo
      this.mostrarPromocionPlantillas = true
    },
    mostrarScoring (obj) {
      this.codigoPromocionEditar = obj.codigo
      this.mostrarPromocionScoring = true
    },
    mostrarCuenta (obj) {
      this.codigoPromocionEditar = obj.codigo
      this.mostrarPromocionCuenta = true
    },
    mostrarDocumentos (obj) {
      this.codigoPromocionEditar = obj.codigo
      this.mostrarPromocionDocumento = true
    },
    async initialize () {
      try {
        this.waitingForLoad = true
        await this.loadPromociones(this.usuario.id)
        this.items = this.promociones.map(x => { return {...x} })
        this.waitingForLoad = false
      } catch (error) {
        this.waitingForLoad = false
        if (!error.code || error.code !== 1) {
          this.addAlert({texto: error.message, color: 'error'})
        }
      }
    }
  },
  watch: {
    cambiado () {
      this.$emit('cambiado', this.cambiado)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/promociones/PromocionesLista.vue